import { useEffect, useState } from "react";
import { Box, Typography, Grid, Paper, Skeleton } from "@mui/material";
import { Line, Bar } from "react-chartjs-2";
import api from "../api/axios";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
);

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api
      .get("/reports/dashboard")
      .then((res) => setStats(res.data))
      .catch(() => setStats({ leads: [], revenue: [], totals: {} }));
  }, []);

  // Safe defaults
  const leads = stats?.leads || [];
  const revenue = stats?.revenue || [];

  const totalLeads = leads.reduce((sum, l) => sum + l.count, 0);
  const totalRevenue = revenue.reduce((sum, r) => sum + r.total, 0);

  return (
    <Box>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Dashboard
      </Typography>

      {/* KPI CARDS */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {[
          { label: "Total Leads", value: totalLeads },
          { label: "Total Revenue (£)", value: totalRevenue.toLocaleString() },
          { label: "Active Services", value: stats?.totals?.services ?? 0 },
          { label: "Completed Orders", value: stats?.totals?.orders ?? 0 },
          { label: "Completed Leads", value: stats?.totals?.leads ?? 0 },
        ].map((card, i) => (
          <Grid item xs={12} sm={6} md={3} key={i}>
            <Paper
              elevation={3}
              sx={{
                p: 3,
                borderRadius: 3,
                background: "linear-gradient(135deg, #1976d2, #42a5f5)",
                color: "#fff",
              }}
            >
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                {card.label}
              </Typography>
              <Typography variant="h4" fontWeight="bold">
                {stats ? card.value : <Skeleton width={60} />}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>

      {/* LEADS CHART */}
      <Paper sx={{ p: 3, mb: 4, borderRadius: 3 }}>
        <Typography variant="h6" gutterBottom>
          Vehicle Remap Leads
        </Typography>

        <Line
          data={{
            labels: leads.length ? leads.map((l) => l.date) : ["No Data"],
            datasets: [
              {
                label: "Leads",
                data: leads.length ? leads.map((l) => l.count) : [0],
                borderColor: "#1976d2",
                backgroundColor: "rgba(25,118,210,0.2)",
                tension: 0.4,
              },
            ],
          }}
          options={{
            responsive: true,
            plugins: {
              legend: { display: true },
            },
          }}
        />
      </Paper>

      {/* REVENUE CHART */}
      <Paper sx={{ p: 3, borderRadius: 3 }}>
        <Typography variant="h6" gutterBottom>
          Revenue (£)
        </Typography>

        <Bar
          data={{
            labels: revenue.length ? revenue.map((r) => r.month) : ["No Data"],
            datasets: [
              {
                label: "Revenue",
                data: revenue.length ? revenue.map((r) => r.total) : [0],
                backgroundColor: "#2e7d32",
              },
            ],
          }}
          options={{
            responsive: true,
            plugins: {
              legend: { display: true },
            },
          }}
        />
      </Paper>
    </Box>
  );
}
